import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import * as Yup from "yup";
import {useFormik} from "formik";
import clsx from "clsx";

import {SendIcon} from "../../../../../components/style-guide/icons";
import {InputGroup} from "../../../../../components";
import {emptyFn, validateEmail} from "../../../../../shared";

import styles from "./SignInForm.module.scss";

export const SignInForm = (props) => {
  const {onSubmit} = props;

  const formFactory = useCallback(formProps => {
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
    } = formProps;
    const error = errors.email && touched.email && errors.email;
    return (
      <>
        <div className="row">
          <div className="col-sm signin-form">
            <InputGroup
              borderRadius={0}
              classNameInputPrefixIcon="rounded-0"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              error={error}
              className={styles.inputGroup}
              placeholder="Correo electrónico"
              trailing={<button type="submit" className={styles.btnSubmit}><SendIcon /></button>}
              trailingClassName={styles.sendIconContainer}/>
          </div>
        </div>
      </>
    );
  }, []);

  const formik = useFormik({
    initialValues: {email: ''},
    validationSchema: Yup.object().shape({
      email: validateEmail,
    }),
    onSubmit
  });

  return (
    <div className={clsx('d-flex flex-column justify-content-center align-items-center mt-5', styles.formContainer)}>
      <h3 className="h3 mb-3 font-weight-normal">Bienvenido</h3>
      <p>
        Ingrese su correo electrónico.
        <br/>
        Le enviaremos un enlace seguro para acceder a sus reportes.
      </p>

      <form onSubmit={formik.handleSubmit}>
        {formFactory(formik)}
      </form>
    </div>
  );
};

SignInForm.propTypes = {
  onSubmit: PropTypes.func
}

SignInForm.defaultProps = {
  onSubmit: emptyFn
}

export default React.memo(SignInForm);
